import bulletlist from './assets/editor/bullet-list.svg'
import bold from './assets/editor/Icon-feather-bold.svg'
import italic from './assets/editor/Icon-feather-italic.svg'
import numberlist from './assets/editor/number-list.svg'
import strike from './assets/editor/strike.svg'
import subscript from './assets/editor/subscript.svg'
import superscript from './assets/editor/superscript.svg'
import underline from './assets/editor/underline.svg'

export const OBJECTIVES = [
  // 'Tutoring my students',
  'Tutoring my learners',
  'Answering common queries',
  'Marking of assessments',
  'Student support',
  'Helpdesk support',
  'Employee onboarding',
  'Information management',
  'Mentoring',
]

export const organizationFlowObject: any = {
  prevRoute: null,
  currentRoute: null,
  nextRoute: null,
  setup_completed: null,
}

export const emojiList = [
  '😀',
  '😁',
  '😂',
  '😃',
  '😉',
  '😋',
  '😎',
  '😍',
  '😗',
  '🤗',
  '🤔',
  '😣',
  '😫',
  '😴',
  '😌',
  '🤓',
  '😛',
  '😜',
  '😠',
  '😇',
  '😷',
  '😈',
  '👻',
  '😺',
  '😸',
  '😹',
  '😻',
  '😼',
  '😽',
  '🙀',
  '🙈',
  '🙉',
  '🙊',
  '👼',
  '👮',
  '🕵',
  '💂',
  '👳',
  '🎅',
  '👸',
  '👰',
  '👲',
  '🙍',
  '🙇',
  '🚶',
  '🏃',
  '💃',
  '⛷',
  '🏂',
  '🏌',
  '🏄',
  '🚣',
  '🏊',
  '⛹',
  '🏋',
  '🚴',
  '👫',
  '💪',
  '👈',
  '👉',
  '👉',
  '👆',
  '🖕',
  '👇',
  '🖖',
  '🤘',
  '🖐',
  '👌',
  '👍',
  '👎',
  '✊',
  '👊',
  '👏',
  '🙌',
  '🙏',
  '🐵',
  '🐶',
  '🐇',
  '🐥',
  '🐸',
  '🐌',
  '🐛',
  '🐜',
  '🐝',
  '🍉',
  '🍄',
  '🍔',
  '🍤',
  '🍨',
  '🍪',
  '🎂',
  '🍰',
  '🍾',
  '🍷',
  '🍸',
  '🍺',
  '🌍',
  '🚑',
  '⏰',
  '🌙',
  '🌝',
  '🌞',
  '⭐',
  '🌟',
  '🌠',
  '🌨',
  '🌩',
  '⛄',
  '🔥',
  '🎄',
  '🎈',
  '🎉',
  '🎊',
  '🎁',
  '🎗',
  '🏀',
  '🏈',
  '🎲',
  '🔇',
  '🔈',
  '📣',
  '🔔',
  '🎵',
  '🎷',
  '💰',
  '🖊',
  '📅',
  '✅',
  '❎',
  '💯',
]

export const supportedFilesKnowledge = [
  // '.doc',
  // '.ppt',
  '.pptx',
  '.docx',
  '.pdf',
  '.txt',
  '.html',
  '.vtt',
  '.srt',
]

export const textBaseFileExtensions = ['.html', '.txt', '.vtt', '.srt']

export const supportedFilesKendra = supportedFilesKnowledge

export const CHANNELS = [
  { value: null, label: 'All Channels' },
  { value: 'webchat', label: 'Web Chat' },
  { value: 'widget', label: 'Widget' },
  { value: 'direct-chat', label: 'Direct Chat' },
  { value: 'teams', label: 'Teams' },
  { value: 'webex', label: 'Webex' },
]

export const IGNORED_EXTENSIONS = [
  'aif',
  'cda',
  'mid',
  'midi',
  'mp3',
  'mpa',
  'ogg',
  'wav',
  'wma',
  'wpl',
  '7z',
  'arj',
  'deb',
  'pkg',
  'rar',
  'rpm',
  'tar.gz',
  'z',
  'zip',
  'bin',
  'dmg',
  'iso',
  'toast',
  'vcd',
  'csv',
  'dat',
  'db',
  'dbf',
  'log',
  'mdb',
  'sav',
  'sql',
  'tar',
  'email',
  'eml',
  'emlx',
  'msg',
  'oft',
  'ost',
  'pst',
  'vcf',
  'apk',
  'bat',
  'bin',
  'cgi',
  'pl',
  'exe',
  'gadget',
  'jar',
  'msi',
  'py',
  'wsf',
  'fnt',
  'fon',
  'otf',
  'ttf',
  'bmp',
  'gif',
  'jpeg',
  'jpg',
  'png',
  'ps',
  'psd',
  'svg',
  'tif',
  'tiff',
  'cer',
  'cfm',
  'cgi',
  'pl',
  'css',
  'js',
  'part',
  'py',
  'key',
  'odp',
  'pps',
  'ppt',
  'pptx',
  'c',
  'cgi',
  'pl',
  'class',
  'cpp',
  'cs',
  'h',
  'java',
  'py',
  'sh',
  'swift',
  'vb',
  'ods',
  'xls',
  'xlsm',
  'xlsx',
  'bak',
  'cab',
  'cfg',
  'cpl',
  'cur',
  'dll',
  'dmp',
  'drv',
  'icns',
  'ico',
  'ini',
  'lnk',
  'msi',
  'sys',
  'tmp',
  '3g2',
  '3gp',
  'avi',
  'flv',
  'h264',
  'm4v',
  'mkv',
  'mov',
  'mp4',
  'mpg',
  'mpeg',
  'rm',
  'swf',
  'vob',
  'wmv',
  'doc',
  'docx',
  'odt',
  'pdf',
  'rtf',
  'tex',
  'wpd',
]

export const sumarieseToolbar: any = {
  options: [
    'history',
    'inline',
    'list',
    // 'link',
    // "embedded",
  ],
  inline: {
    inDropdown: false,
    className: 'markdown-toolbar-option',
    component: undefined,
    dropdownClassName: undefined,
    options: [
      'bold',
      'italic',
      // "underline",
      // "strikethrough",
      // "monospace",
      // "superscript",
      // "subscript",
    ],
    bold: { icon: bold, className: 'option-bold' },
    italic: { icon: italic, className: 'demo-option-custom' },
    underline: { icon: underline, className: 'markdown-toolbar-icon' },
    strikethrough: { icon: strike, className: 'markdown-toolbar-icon' },
    // monospace: { icon: monospace, className: "markdown-toolbar-icon" },
    superscript: { icon: superscript, className: 'markdown-toolbar-icon' },
    subscript: { icon: subscript, className: 'markdown-toolbar-icon' },
  },
  list: {
    inDropdown: false,
    className: 'markdown-toolbar-option',
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered'],
    unordered: { icon: bulletlist, className: 'emo-option-custom' },
    ordered: { icon: numberlist, className: 'emo-option-custom' },
    // indent: { icon: indent, className: undefined },
    // outdent: { icon: outdent, className: undefined },
  },
}
